import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Detect MSAL v5 popup redirect by inspecting the state parameter in the hash.
// We cannot rely on window.opener because Azure AD's Cross-Origin-Opener-Policy
// severs the opener reference during cross-origin navigation.
function detectMsalPopupRedirect(): { channelId: string; hash: string } | null {
  const rawHash = globalThis.location.hash;
  if (!rawHash.includes('code=') || !rawHash.includes('state=')) {
    return null;
  }

  try {
    const hash = rawHash.substring(1); // Remove leading #
    const params = new URLSearchParams(hash);
    const state = params.get('state');
    if (!state) return null;

    const stateObj = JSON.parse(atob(state));
    if (stateObj.meta?.interactionType === 'popup' && stateObj.id) {
      return { channelId: stateObj.id, hash };
    }
  } catch {
    // Not a valid MSAL state - proceed with normal bootstrap
  }
  return null;
}

const msalRedirect = detectMsalPopupRedirect();

if (msalRedirect) {
  // This window is an MSAL popup redirect. Broadcast the auth response
  // to the parent window via BroadcastChannel (MSAL v5 mechanism), then close.
  console.log('[MSAL Popup] Auth response detected, broadcasting to parent...');
  const channel = new BroadcastChannel(msalRedirect.channelId);
  channel.postMessage({ v: 1, payload: msalRedirect.hash });
  channel.close();
  console.log('[MSAL Popup] Broadcast complete, closing popup.');

  // Clean up the URL hash
  if (typeof globalThis.history?.replaceState === 'function') {
    globalThis.history.replaceState(null, '', `${globalThis.location.origin}${globalThis.location.pathname}`);
  }

  try {
    globalThis.close();
  } catch {
    /* popup close may be restricted */
  }
} else {
  bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => console.error(err));
}
